import CampaignTable from './CampaignTable';
import './tabStyles.css';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useParams } from 'react-router';
import { useEffect } from 'react';
// import {
//   resetCampaignData,
//   resetCampaignPagination,
// } from "../../reducers/WcaCampaignlice";
import TrailDashboard from '../../TrailDashboard';
import { resetCampaignData, resetCampaignPagination } from '../../../reducers/campaignSlice';

const WcaCampaign = () => {
  const { userSub } = useSelector((state) => state.authenticate);
  const { id } = useParams();
  const dispatch = useDispatch();
  const renderCampaign = () => {
    if (id) return <Outlet />;
    else return <CampaignTable />;
  };

  useEffect(() => {
    return () => {
      dispatch(resetCampaignData());
      dispatch(resetCampaignPagination());
    };
  }, []);
  return (
    <div className="w-full p-2 m-auto">
      {!userSub.isUserSub ? <TrailDashboard /> : renderCampaign()}
    </div>
  );
};

export default WcaCampaign;
